export default {
  pt: {
    LOGIN_WITH_FACEBOOK_SING_UP: 'Entrar com Facebook',
    LOGIN_WITH_GOOGLE_SING_UP: 'Entrar com Google',
    LOGIN_WITH_FACEBOOK_SIGN_IN: 'Entrar com Facebook',
    LOGIN_WITH_GOOGLE_SIGN_IN: 'Entrar com Google',
    LOGIN_WITH_MICROSOFT_SIGN_IN: 'Entrar com Microsoft',
    LOGIN_WITH_MICROSOFT_SECURE_AUTH: 'Entrar com SecureAuth',
    LOGIN_WITH_OPENAGORA: 'Entrar com Openagora',

    AUTH_VALIDATION_LEGALS_REQUIRED:
      'Você deve aceitar os Termos, Condições e Políticas para se registrar.',
    INPUT_REQUIRED: 'Campo obrigatório',
    VALIDATE_MAX_PASSWORD: 'Sua senha deve ter no máximo 6 caracteres',
    VALIDATE_MIN_PASSWORD: 'Sua senha deve ter pelo menos 6 caracteres',
    VALIDATE_FORMAT_EMAIL: 'Por favor digite um email válido.',
    PASSWORD_DOES_NOT_MATCH: 'As senhas não correspondem',

    LEGALS_TEXT_1: 'Aceito os ',
    LEGALS_TEXT_2: 'Termos, Condições e Políticas de Crehana.',

    CONTINUE_WITH: 'Continue com:',

    SENDING: 'Enviando...',
    GENERIC_ERROR: 'Ocorreu um erro. Tente novamente.',
    // CORE-1795 (scope change): CAPTCHA_ERROR/CAPTCHA_UNCONFIGURED_ERROR removed —
    // Turnstile no longer mounts on these 3 recovery forms. No RATE_LIMITED_ERROR key
    // here either: `request_password_recovery` (the mutation these forms call) NEVER
    // returns error_code `rate_limited` — it always responds `success=True` even when
    // throttled, by BE design (anti-enumeration + silent-throttling, Confluence
    // 1987248131 §6.1). Only `change_password_with_recovery` (B2BOrgResetPassword) can
    // signal it — see that page's own i18n locale files.

    B2C_EMAIL_MESSAGE:
      '* Se você é um estudante de administração. [Clique aqui]({{url}})',
    B2B_EMAIL_ACTIVATE_MESSAGE:
      '* Você ainda não ativou sua conta. [Ative aqui]({{url}})',
    B2B_EMAIL_REGISTERED_MESSAGE:
      '* Conta corporativa já registrada. [Iniciar sessão]({{url}})',
    AUTH_VALIDATION_EMAIL_IN_USE: 'O e-mail inserido já está em uso',

    OVERLAY_ERROR_TITLE: 'Opa, algo deu errado',
    OVERLAY_ERROR_BUTTON_TRY_AGAIN_LABEL: 'Tentar de novo',
  },
};
